import { createApp } from 'vue'
import App from './App.vue'
import "./assets/common.less";

createApp(App).mount('#app')

document.title = "JS Is Weird";